import cn from '@sindresorhus/class-names';
import {BaseHeaderButton} from '@ui-kit/src/Header';
import {useCallback, useEffect, useState} from 'react';

import {SpriteIcon} from '@web-catalog/ui-kit/SpriteIcon';

import {SearchModal} from '../../../SearchModal';
import {YmLogger} from '../../YmLogger';
import styles from './HeaderSearch.module.scss';

export const HeaderSearch = () => {
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);

  const onHandleClick = useCallback(() => {
    setIsSearchBoxOpen(true);
    YmLogger.logSearchBoxOpenClick();
  }, []);

  useEffect(() => {
    //Костыль, чтобы при открытии модалки поиска добавляемый к html padding добавился к header-у, иначе он сдвигается
    const header = document.querySelector('header');

    const observer = new MutationObserver(function () {
      if (header) {
        header.style.paddingRight = document.documentElement.style.paddingRight;
      }
    });

    const target = document.documentElement;
    observer.observe(target, {attributes: true, attributeFilter: ['style']});

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={cn(styles.search)}>
      <BaseHeaderButton
        hoverVariant="light"
        onClick={onHandleClick}
        aria-label="Открыть поиск"
        data-testid="header_search_button"
      >
        <SpriteIcon svg="search" size={20} />
        <span className={styles.searchText}>Поиск</span>
      </BaseHeaderButton>
      <SearchModal
        isOpen={isSearchBoxOpen}
        setIsOpen={(value: boolean) => setIsSearchBoxOpen(value)}
      />
    </div>
  );
};
